import { render, staticRenderFns } from "./consultingRecords.vue?vue&type=template&id=752368e9&scoped=true&"
import script from "./consultingRecords.vue?vue&type=script&lang=js&"
export * from "./consultingRecords.vue?vue&type=script&lang=js&"
import style0 from "./consultingRecords.vue?vue&type=style&index=0&id=752368e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752368e9",
  null
  
)

export default component.exports